import {Button, Input} from "@varymadellc/my-weed-club-component-library";
import {TbDeviceDesktopShare} from "react-icons/tb";
import React, {Children, cloneElement, ReactElement} from "react";
import {apiPost, extractPayloadFromResponse} from "@/services/apiService";
import Tooltip from "@/components/Tooltip";
import copyText from "@/utils/copyText";
import {useSiteMessage} from "@/providers/SiteMessageProvider";

export interface QueueQuickShareProps {
    authToken: string;
    userUuid: string;
}

// TODO this be ugly yo, too many props and not really much flow yo!
function setQueueQuickShare(minutes: number, userUuid, authToken, setMessage, setSubmenuValue, openQueue: boolean = false) {
    return async (event) => {
        event.preventDefault();

        try {
            const response = await apiPost(`/account/${userUuid}/queue-access-code`, JSON.stringify({
                expirationDate: new Date(Date.now() + minutes * 60 * 1000)
            }), authToken);

            const {data} = await extractPayloadFromResponse(response);

            if (data) {
                const url = `${window.location.protocol}//${window.location.host}/q/code/${data.code}`;

                setSubmenuValue(data.code, url);

                if (openQueue) {
                    window.open(url);
                }
            }
        } catch (error) {
            console.error(error);
        }
    }
}

function stylizeMenuItems(children) {
    return Children.map(children, (child, index) => {
        return cloneElement(child, {
            key: index,
            className: "flex flex-1 h-full w-full justify-center items-center text-sm w-[50px]"
        });
    });
}

export default function QueueQuickShare({userUuid, authToken}: QueueQuickShareProps) {
    const [submenuValue, setSubmenuValue] = React.useState<string>('');

    const {setMessage} = useSiteMessage();

    const [menuIndex, setMenuIndex] = React.useState<number>(0);

    const menu: ReactElement[] = [
        <Button key="day" onClick={setQueueQuickShare(60 * 24 * 365 * 10, userUuid, authToken, setMessage, setSubmenuValue, true)}>
            <TbDeviceDesktopShare className="h-full"/>
        </Button>,
        <Button key="30mins" onClick={setQueueQuickShare(30, userUuid, authToken, setMessage, setSubmenuValue)}>30m</Button>,
        <Button key="60mins" onClick={setQueueQuickShare(60, userUuid, authToken, setMessage, setSubmenuValue)}>1hr</Button>,
        <Button key="720mins" onClick={setQueueQuickShare(60 * 12, userUuid, authToken, setMessage, setSubmenuValue)}>12hr</Button>,
    ];

    const rotatedMenuIndex = Math.floor(menuIndex % menu.length * -1);

    return (
        <div className="flex w-[180px] h-full flex-row justify-end">
            <div className="flex flex-row">
                <div onClick={() => {
                    setSubmenuValue('');

                    setMenuIndex((menuIndex) => menuIndex - 1)
                }}
                     className="flex justify-center items-center p-1 bg-primary/50 color-white w-[20px] overflow-hidden">
                    {`>`}
                </div>
                <div className="w-[60px] sm:w-[40px]">
                    {
                        stylizeMenuItems(menu[rotatedMenuIndex])
                    }
                </div>
            </div>
            <Input onClick={() => copyText(submenuValue, (wasCopied) => {
                if (!submenuValue || !wasCopied) return;

                setMessage('Copied to clipboard');
            })} className="w-[120px]" readOnly value={submenuValue} placeholder="code..."/>
        </div>
    );
}